import React from 'react';
import { jsx } from '@emotion/core';
import moment from 'moment';
import { ContributionSource } from '../../../utils/types';
import DataTable from '../../../components/table/DataTable';
/**@jsx jsx*/

type Actions = {
  label: string;
  action: (gender: ContributionSource) => void;
}[];

interface IProps {
  contributionSources?: ContributionSource[];
  actions: Actions;
  isLoading?: boolean;
}

const columns = [
  {
    title: 'Id',
    dataIndex: 'id',
    key: 'id',
  },
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: 'Created At',
    dataIndex: 'createdAt',
    key: 'createdAt',
    render: (createdAt: Date) => {
      return <span>{moment(createdAt).format('DD/MM/YYYY')}</span>;
    },
  },
  {
    title: 'Last Changed',
    dataIndex: 'lastChanged',
    key: 'lastChanged',
    render: (lastChanged: Date) => {
      return <span>{moment(lastChanged).format('DD/MM/YYYY')}</span>;
    },
  },
];

const ContributionSourcesTable: React.FC<IProps> = ({
  contributionSources = [],
  actions,
  isLoading,
}) => {
  return (
    <DataTable
      showControls
      showPagination
      data={contributionSources}
      columns={columns}
      actions={actions}
      searchFilter="name"
      isLoading={isLoading}
    />
  );
};

export default ContributionSourcesTable;
